import React from "react";
import { Helmet } from "react-helmet";
import {
  DEFAULT_OG_IMAGE,
  SITE_ORIGIN,
  organizationJsonLd,
} from "./site";

export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
  type = "website",
  noindex = false,
  extraGraph = [],
  breadcrumbs = [],
}) {
  const canonicalPath = path === "/" ? "/" : path;
  const canonical = `${SITE_ORIGIN}${canonicalPath}`;
  const breadcrumbList =
    breadcrumbs.length > 1
      ? {
          "@type": "BreadcrumbList",
          itemListElement: breadcrumbs.map((crumb, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: crumb.name,
            item: `${SITE_ORIGIN}${crumb.path === "/" ? "/" : crumb.path}`,
          })),
        }
      : null;
  const graph = {
    "@context": "https://schema.org",
    "@graph": [organizationJsonLd, breadcrumbList, ...extraGraph].filter(Boolean),
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow"}
      />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Connct" />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <script type="application/ld+json">{JSON.stringify(graph)}</script>
    </Helmet>
  );
}
